module.exports = __webpack_public_path__ + "static/media/Item_Weapon_MG3_C.b8e69794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_MG3_C.png
// module id = 229
// module chunks = 0